import { WidgetActionButton } from '../widgets/components/widget-footer/widget-footer.types';
import { WidgetActionName } from '../widgets/core/widget.consts';
import { SectionDef } from '../widgets/core/widget.types';

export const SLOTS_FIELDS_KEY = 'SLOTS_MODULE_FORMKEY';

export const SLOTS_COLUMN_LIST = 'column_list-slots';

export const DOWNLOAD_FILENAME = 'slots';

const translationBase = 'defaultFields.slots-module';

export const SLOTS_MODULE_URL = '/material-management/slots';

export const ROW_SECTIONS: SectionDef[] = [
  {
    align: 'start',
    fields: [
      { key: 'code', strong: true, tooltip: `${translationBase}.slotCode` },
      { date: true, key: 'dateFrom', tooltip: `${translationBase}.dateFrom` },
    ],
  },
  {
    align: 'end',
    fields: [
      { key: 'type', strong: true, tooltip: `${translationBase}.slotType`, uppercase: true },
      { date: true, key: 'dateTo', tooltip: `${translationBase}.dateTo` },
    ],
  },
];

export const actionButtons: WidgetActionButton[] = [
  {
    color: 'primary',
    icon: 'open_in_new',
    label: 'slotListWidget.redirect',
    name: WidgetActionName.REDIRECT,
    raised: true,
    tooltip: 'slotListWidget.redirect',
  },
  {
    color: 'accent',
    icon: 'cloud_download',
    label: 'slotListWidget.download',
    name: WidgetActionName.DOWNLOAD,
    raised: true,
    tooltip: 'slotListWidget.download',
  },
];
